export default {
  nodes: [
		{
			id: '11',
			name: '初入职场',
		},
    {
      id: '1',
      name: '招聘',
      conf: [],
    },
    {
      id: '2',
      name: '培训',
      conf: [],
    },
    {
      id: '3',
      name: '绩效管理',
      conf: [],
    },
    {
      id: '4',
      name: '员工关系',
      conf: [],
    },
    {
      id: '5',
      name: '人力资源助理',
      conf: [],
    },
    {
      id: '6',
      name: '人力资源专员',
      conf: [],
    },
    {
      id: '7',
      name: '高级人力资源专员',
      conf: [],
    },
    {
      id: '8',
      name: '人力资源经理',
      conf: [],
    },
    {
      id: '9',
      name: '人力资源业务伙伴',
      conf: [],
    },
    {
      id: '10',
      name: '人力资源总监',
      conf: [],
    }
  ],
  edges: [
    {
      source: '11',
      target: '1',
    },
    {
      source: '11',
      target: '2',
    },
    {
      source: '11',
      target: '3',
    },
    {
      source: '11',
      target: '4',
    },
    {
      source: '1',
      target: '5',
    },
    {
      source: '2',
      target: '5',
    },
    {
      source: '3',
      target: '5',
    },
    {
      source: '4',
      target: '5',
    },
    {
      source: '5',
      target: '6',
    },
    {
      source: '6',
      target: '7',
    },
    {
      source: '7',
      target: '8',
    },
    {
      source: '7',
      target: '9',
    },
    {
      source: '8',
      target: '10',
    },
    {
      source: '9',
      target: '10',
    }
  ],
};